<!-- The thread header's own bar, describing the group the same way, with the way back to the conversation. -->
<div class="panes-header">
  <button type="button" class="chat-icon-button panes-header__back" (click)="back.emit()" aria-label="Back to conversation"
          matTooltip="Back to conversation"><i class="fa-solid fa-angle-left" aria-hidden="true"></i></button>
  <span class="panes-faces" aria-hidden="true">
    <ngx-stored-gravatar *ngFor="let face of faces; let first = first" [email]="face.email" [name]="face.name"
                         [style]="first ? groupFaceStyle : groupFaceRingStyle"></ngx-stored-gravatar>
  </span>
  <span class="panes-header__who">
    <span class="panes-header__name">{{ conversation?.title }}</span>
    <span class="panes-header__address">{{ address }}</span>
  </span>
</div>

<!-- Who is in it, and who could be: the overview's own segmented control. Add only for one who may manage. -->
<div class="panes-tabs">
  <div class="chat-seg" role="tablist" aria-label="Group membership">
    <button type="button" role="tab" class="chat-seg__segment" [attr.aria-selected]="pane === 'in'"
            (click)="pane = 'in'">Members</button>
    <button *ngIf="canManage" type="button" role="tab" class="chat-seg__segment" [attr.aria-selected]="pane === 'add'"
            (click)="pane = 'add'">Add</button>
  </div>
</div>

<div class="chat-scroll">
  <ul class="chat-list" *ngIf="rows.length; else noMembers">
    <li class="chat-list__item" *ngFor="let row of rows; trackBy: trackByEmail">
      <span class="chat-row chat-row--static">
        <span class="chat-row__face" aria-hidden="true">
          <messenger-presence-face [status]="statusOf(row)" [size]="44">
            <ngx-stored-gravatar [email]="row.email" [name]="row.name" [style]="faceStyle"></ngx-stored-gravatar>
          </messenger-presence-face>
        </span>
        <span class="chat-row__text">
          <span class="chat-row__line">
            <span class="chat-row__name">{{ row.name }}</span>
            <!-- The member's role, as text (ITP-E-204-07); the only admin's says why it cannot change. -->
            <span *ngIf="pane === 'in'" class="chat-row__role"
                  [attr.title]="isOnlyAdmin(row) ? 'Only admin' : null">{{ roleLabelOf(row) }}</span>
          </span>
          <span class="chat-row__line"><span class="chat-row__last">{{ row.email }}</span></span>
        </span>
        <!-- One control per row (ITP-E-204-07, Q13): a member's ⋯ menu, or + with the role to add as. -->
        <button *ngIf="pane === 'in' && rowItemsOf(row).length" type="button" class="chat-icon-button panes-act"
                [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{row: row}" [attr.aria-label]="rowMenuLabelOf(row)">
          <i class="fa-regular fa-ellipsis" aria-hidden="true"></i></button>
        <button *ngIf="pane === 'add' && addRoles.length" type="button" class="chat-icon-button panes-act"
                [matMenuTriggerFor]="addMenu" [matMenuTriggerData]="{row: row}"
                [attr.aria-label]="'Add ' + row.name + ' to ' + conversation?.title" matTooltip="Add">
          <i class="fa-regular fa-plus" aria-hidden="true"></i></button>
      </span>
    </li>
  </ul>
  <mat-menu #rowMenu="matMenu" xPosition="before">
    <ng-template matMenuContent let-row="row">
      <button mat-menu-item *ngFor="let item of rowItemsOf(row)" (click)="onRowItem(row, item)">{{ rowItemLabel(item) }}</button>
    </ng-template>
  </mat-menu>
  <mat-menu #addMenu="matMenu" xPosition="before">
    <ng-template matMenuContent let-row="row">
      <button mat-menu-item *ngFor="let role of addRoles" (click)="onAddAs(row, role)">{{ addRoleLabel(role) }}</button>
    </ng-template>
  </mat-menu>
  <ng-template #noMembers>
    <div class="chat-empty" role="status">No members.</div>
  </ng-template>
</div>
